import api from '../api'; // import your configured axios instance
import { API_URL } from '../config';


// GET the org chart
export const getOrgChart = async () => {
  const response = await api.get(`${API_URL}/orgchart`);
  return response.data;
};

// POST org chart 
export const saveOrgChart = async (formData) => {
  try {
    const response = await api.post(`${API_URL}/orgchart/save`, formData);
    return response.data;
  } catch (error) {
    console.error('Error saving org chart:', {
      message: error.message,
      response: error.response ? {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data
      } : null,
      request: error.request ? error.request : null
    });
    throw error.response?.data || error.message;
  }
};

// DELETE org chart
export const deleteOrgChart = async () => {
  const response = await api.delete(`${API_URL}/orgchart/clear`);
  return response.data;
};